import { useRef } from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';

import { useLockBodyScrollVertical } from '@hooks';
import { useModal } from 'context/ModalContext';

const customStyles = {
    overlay: {
        zIndex: '998',
        backgroundColor: 'rgba(0,0,0, .6)',
    },
};

Modal.setAppElement('#__next');

const LeftMenuModal = ({ children }) => {
    const { closeLeftMenuModal, leftMenuModalIsOpen } = useModal();
    const modalRef = useRef(null);

    useLockBodyScrollVertical(leftMenuModalIsOpen);
    return (
        <MenuModal
            isOpen={leftMenuModalIsOpen}
            onRequestClose={closeLeftMenuModal}
            style={customStyles}
            ref={modalRef}
            contentLabel="Left Menu Modal"
        >
            {children}
        </MenuModal>
    );
};
const MenuModal = styled(Modal)`
    position: fixed;
    top: 0;
    right: 0;
    left: auto;
    bottom: auto;
    width: 100%;
    height: 100dvh;
    opacity: 0.98;
    background: ${({ theme }) => theme.colors.secondary};
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    ::-webkit-scrollbar {
        display: none;
    }
`;
export default LeftMenuModal;
